import type { BaseUsecase } from '@usecases/base-usecase';

export interface SendDigitsEventPublisher {
  publish(digits: string): Promise<void>;
}

export type SendDigitsUsecase = BaseUsecase<string, void>;

export class SendDigits implements SendDigitsUsecase {
  constructor(private publisher: SendDigitsEventPublisher) {}

  async run(req: string): Promise<void> {
    await this.publisher.publish(req);
  }
}
